import type { Author } from '~/utils/solr/author'
import { getLastName } from '#shared/utils/solr-facet'
import { sortByPrimaryIdentity } from '~/utils/catalogue-relevance'
import { compareLocaleNorwegian, normalizeNorwegianSort } from '~/utils/string'

function compareSurname(left: Author, right: Author): number {
  const leftSurname = normalizeNorwegianSort(left.surname || getLastName(left.name))
  const rightSurname = normalizeNorwegianSort(right.surname || getLastName(right.name))
  return compareLocaleNorwegian(leftSurname, rightSurname)
}

export function sortAuthorCatalogue(items: readonly Author[], query: string): Author[] {
  return sortByPrimaryIdentity(items, query, (item) => [item.name], compareSurname)
}
